// Module
var code = `<!-- ko using: model -->
<div class="svc-creator-tab__content svc-translation-tab" data-bind="css: { 'svc-translation-tab--empty': \$data.isEmpty }">
  <!-- ko if: \$data.isEmpty -->
  <svc-surface-placeholder params="name: 'translation', placeholderTitleText: \$data.placeholderTitleText, placeholderDescriptionText: \$data.placeholderDescriptionText"></svc-surface-placeholder>
  <!-- /ko -->
  <!-- ko ifnot: \$data.isEmpty -->
  <div class="st-content">
    <div class="svc-flex-column st-strings-wrapper">
      <div class="svc-flex-row st-strings-header">
        <!-- ko template: { name: 'survey-content', data: \$data.stringsHeaderSurvey  } --><!-- /ko -->
      </div>
      <div class="svc-flex-row svc-plugin-tab__content st-strings">
        <!-- ko template: { name: 'survey-content', data: \$data.stringsSurvey  } --><!-- /ko -->
      </div>
    </div>
  </div>
  <!-- /ko -->
</div>
<!-- /ko -->`;
// Exports
export default code;